"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColors = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _tableColumn = _interopRequireDefault(require("./_table-column"));

var _tableHeader = _interopRequireDefault(require("./_table-header"));

var _tooltip = _interopRequireDefault(require("../../atoms/tooltip"));

var _versions = require("../../_utils/versions");

var _components = require("./_components");

var _tableFooter = _interopRequireDefault(require("./_table-footer"));

var _context = require("../../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getColors = function getColors(props) {
  return (0, _versions.getColor)(props, 'table');
};

exports.getColors = getColors;
var Components = {
  MayOverflow: _components.MayOverflow,
  SubField: _components.SubField
};

var MayOverflowWithTooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MayOverflowWithTooltip, _React$Component);

  function MayOverflowWithTooltip() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MayOverflowWithTooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MayOverflowWithTooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      wrapWithTooltip: false
    });

    _defineProperty(_assertThisInitialized(_this), "isClipped", function () {
      return _this.content.offsetWidth < _this.content.scrollWidth;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.isClipped()) _this.setState({
        wrapWithTooltip: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      var isClipped = _this.isClipped();

      if (isClipped) {
        if (!prevState.wrapWithTooltip) _this.setState({
          wrapWithTooltip: true
        });
      } else {
        if (prevState.wrapWithTooltip) _this.setState({
          wrapWithTooltip: false
        });
      }
    });

    return _this;
  }

  _createClass(MayOverflowWithTooltip, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var Component = Components[this.props.type];

      if (this.state.wrapWithTooltip) {
        return _react["default"].createElement(_tooltip["default"], {
          position: "bottom",
          content: this.props.children
        }, _react["default"].createElement(Component, {
          innerRef: function innerRef(e) {
            return _this2.content = e;
          },
          version: this.props.version
        }, this.props.children));
      }

      return _react["default"].createElement(Component, {
        innerRef: function innerRef(e) {
          return _this2.content = e;
        }
      }, this.props.children);
    }
  }]);

  return MayOverflowWithTooltip;
}(_react["default"].Component);

var defaultCellRenderer = function defaultCellRenderer(version) {
  return function (item, index, column) {
    return column.subField ? _react["default"].createElement("span", null, _react["default"].createElement(MayOverflowWithTooltip, {
      type: 'MayOverflow',
      version: version
    }, item[column.field]), _react["default"].createElement(MayOverflowWithTooltip, {
      type: 'SubField',
      version: version
    }, item[column.subField])) : _react["default"].createElement(MayOverflowWithTooltip, {
      type: 'MayOverflow',
      version: version
    }, item[column.field]);
  };
};

var Table =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(Table, _React$Component2);

  //eslint-disable-line
  function Table(_props) {
    var _this3;

    _classCallCheck(this, Table);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, _props));

    _defineProperty(_assertThisInitialized(_this3), "componentWillReceiveProps", function (newProps) {
      _this3.columns = _this3.getColumns(newProps);

      _this3.setState({
        items: _this3.getDisplayedItems(_this3.columns, newProps.items)
      });
    });

    _defineProperty(_assertThisInitialized(_this3), "getColumns", function (props) {
      return _react["default"].Children.toArray(props.children).map(function (element) {
        return element.props;
      });
    });

    _defineProperty(_assertThisInitialized(_this3), "getDisplayedItems", function (columns, allItems) {
      var items = _toConsumableArray(allItems);

      var sortColumn = columns.find(function (column) {
        return column.sort;
      });
      if (!sortColumn || items.length === 0) return items;

      var comparator = sortColumn.comparator || _this3.guessComparator(items[0], sortColumn);

      items.sort(function (row1, row2) {
        return comparator(sortColumn, row1, row2);
      });
      if (sortColumn.sort === 'desc') items.reverse();
      return items;
    });

    _defineProperty(_assertThisInitialized(_this3), "guessComparator", function (firstItem, sortColumn) {
      var sampleValue = firstItem[sortColumn.field];
      if (typeof sampleValue === 'number') return Table.compare.numbers;
      return Table.compare.strings;
    });

    _defineProperty(_assertThisInitialized(_this3), "onSort", function (sortForColumn) {
      _this3.columns = _this3.columns.map(function (column) {
        if (sortForColumn.field === column.field) {
          var sort = 'asc';
          if (column.sort === 'asc') sort = 'desc';
          return _objectSpread({}, column, {
            sort: sort
          });
        }

        if (column.sort) {
          return _objectSpread({}, column, {
            sort: ''
          });
        }

        return column;
      });

      _this3.setState({
        items: _this3.getDisplayedItems(_this3.columns, _this3.props.items)
      });
    });

    _defineProperty(_assertThisInitialized(_this3), "onSelection", function (rowData) {
      return function () {
        if (_this3.props.selectable) {
          _this3.props.onSelection(rowData);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this3), "onResizeHover", function (field, hovering) {
      _this3.setState(function (prevState) {
        return _defineProperty({}, field, _objectSpread({}, prevState[field], {
          resizeHover: hovering
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this3), "onResizeStart", function (field) {
      _this3.setState(function (prevState) {
        return _defineProperty({}, field, _objectSpread({}, prevState[field], {
          resizeHover: false,
          resizeStart: true,
          resizeStop: false
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this3), "onResizeStop", function (field, width) {
      _this3.setState(function (prevState) {
        return _defineProperty({}, field, _objectSpread({}, prevState[field], {
          resizeHover: false,
          resizeStart: false,
          resizeStop: true
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this3), "getRows", function (version) {
      return _this3.state.items.map(function (item, index) {
        return _react["default"].createElement(Table.Row, {
          selectable: _this3.props.selectable,
          key: "row-".concat(index)
        }, _this3.columns.map(function (column) {
          var cellRenderer = column.children || defaultCellRenderer(version);
          var field = _this3.state[column.field];
          var resizeHover = field ? field.resizeHover : false;
          var resizeStart = field ? field.resizeStart : false;
          var resizeStop = field ? field.resizeStop : false;
          return _react["default"].createElement(Table.Cell, {
            key: column.field,
            resizing: resizeStart,
            column: column,
            version: version,
            clickable: column.clickable
            /* clickable prop means that the column contains a child which is clickble like icon popover 
               then in this case we should not fire onSelection of the row 
            */
            ,
            onClick: !column.clickable && _this3.onSelection(item)
          }, _react["default"].createElement(Table.Text, {
            version: version
          }, cellRenderer(item, index, column)), _react["default"].createElement(_components.ResizeCellGrip, {
            resizeHover: resizeHover,
            resizeStart: resizeStart,
            resizeStop: resizeStop,
            version: version
          }));
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this3), "getFixedHeaderTable", function () {
      var _this3$props = _this3.props,
          version = _this3$props.version,
          headerHover = _this3$props.headerHover,
          headerBorder = _this3$props.headerBorder,
          headerSeparator = _this3$props.headerSeparator,
          resizeGripHeight = _this3$props.resizeGripHeight,
          fixedHeader = _this3$props.fixedHeader,
          height = _this3$props.height,
          children = _this3$props.children,
          minWidth = _this3$props.minWidth;
      return _react["default"].createElement(_components.FixedHeaderDiv, {
        innerRef: function innerRef(el) {
          return _this3.container = el;
        }
      }, _react["default"].createElement(Table.Element, {
        fixedHeader: fixedHeader
      }, _react["default"].createElement(Table.Header, {
        columns: _this3.columns,
        onSort: _this3.onSort,
        onResizeHover: _this3.onResizeHover,
        onResizeStart: _this3.onResizeStart,
        onResizeStop: _this3.onResizeStop,
        version: version,
        fixedHeader: fixedHeader,
        headerBorder: headerBorder,
        headerSeparator: headerSeparator,
        resizeGripHeight: resizeGripHeight,
        headerHover: headerHover,
        container: _this3.container,
        minWidth: minWidth
      })), _react["default"].createElement(_components.ScrollDiv, {
        height: height
      }, _react["default"].createElement(Table.Element, null, _react["default"].createElement(Table.Header, {
        columns: _this3.columns,
        version: version,
        hidden: true,
        minWidth: minWidth
      }), _react["default"].createElement(Table.Body, {
        version: version,
        children: children
      }, _this3.getRows(version)), _this3.props.footerFields ? _react["default"].createElement(Table.Footer, {
        footerItems: _this3.getFooter(_this3.props.footerFields, _this3.props.items, _this3.columns)
      }) : null)));
    });

    _defineProperty(_assertThisInitialized(_this3), "getFooter", function (footerFields, items, columns) {
      var sumOfFields = footerFields.map(function (field) {
        var temp = {};
        var sumOfField = items.reduce(function (acc, item) {
          acc[field] = acc[field] + item[field];
          return acc;
        }, _defineProperty({}, field, 0));
        return sumOfField[field];
      });
      var footerItems = columns.map(function (column) {
        var index = footerFields.indexOf(column.field);
        return index >= 0 ? sumOfFields[index] : null;
      });
      return ['Total'].concat(_toConsumableArray(footerItems.slice(1)));
    });

    _defineProperty(_assertThisInitialized(_this3), "getTable", function () {
      var _this3$props2 = _this3.props,
          version = _this3$props2.version,
          headerHover = _this3$props2.headerHover,
          headerBorder = _this3$props2.headerBorder,
          headerSeparator = _this3$props2.headerSeparator,
          resizeGripHeight = _this3$props2.resizeGripHeight,
          minWidth = _this3$props2.minWidth;
      return _react["default"].createElement(Table.Element, null, _react["default"].createElement(Table.Header, {
        columns: _this3.columns,
        onSort: _this3.onSort,
        onResizeHover: _this3.onResizeHover,
        onResizeStart: _this3.onResizeStart,
        onResizeStop: _this3.onResizeStop,
        version: version,
        headerBorder: headerBorder,
        headerSeparator: headerSeparator,
        resizeGripHeight: resizeGripHeight,
        headerHover: headerHover,
        minWidth: minWidth
      }), _react["default"].createElement(Table.Body, _this3.props, _this3.getRows(version)), _this3.props.footerFields ? _react["default"].createElement(Table.Footer, {
        footerItems: _this3.getFooter(_this3.props.footerFields, _this3.props.items, _this3.columns)
      }) : null);
    });

    _this3.columns = _this3.getColumns(_props);
    _this3.state = {
      items: _this3.getDisplayedItems(_this3.columns, _props.items),
      maxWidth: {}
    };
    return _this3;
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fixedHeader = _this$props.fixedHeader,
          height = _this$props.height; //* Return table with fixed header

      if (fixedHeader && height) return this.getFixedHeaderTable(); //* return normal table

      return this.getTable();
    }
  }]);

  return Table;
}(_react["default"].Component);

Table.compare = {
  numbers: function numbers(column, row1, row2) {
    return Number(row1[column.field]) - Number(row2[column.field]);
  },
  strings: function strings(column, row1, row2) {
    return String(row1[column.field]).toLowerCase().localeCompare(String(row2[column.field]).toLowerCase());
  },
  stringsCaseSensitive: function stringsCaseSensitive(column, row1, row2) {
    return String(row1[column.field]).localeCompare(String(row2[column.field]));
  }
};
Table.Header = _tableHeader["default"];
Table.Column = _tableColumn["default"];
Table.Element = _components.TableElement;
Table.Body = _components.TableBody;
Table.Cell = _components.TableCell;
Table.Row = _components.TableRow;
Table.Text = _components.TableText;
Table.Footer = _tableFooter["default"];
Table.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  selectable: _propTypes["default"].bool,
  fixedHeader: _propTypes["default"].bool,
  height: _propTypes["default"].string,
  minWidth: _propTypes["default"].string,
  bottomBorder: _propTypes["default"].bool,
  headerHover: _propTypes["default"].bool,
  headerSeparator: _propTypes["default"].bool,
  onSelection: _propTypes["default"].func,
  headerBorder: _propTypes["default"].string,
  resizeGripHeight: _propTypes["default"].oneOf(['full', 'small'])
};
Table.defaultProps = {
  fixedHeader: false,
  minWidth: '104px',
  selectable: false,
  headerBorder: '3px',
  headerHover: true,
  headerSeparator: false,
  bottomBorder: false,
  resizeGripHeight: 'full',
  onSelection: _noop2["default"]
};
Table.displayName = 'Table';

var _default = (0, _context.withVersion)(Table);

exports["default"] = _default;